import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core'

import * as R from 'ramda'
import React, { FC } from 'react'
import styled from 'styled-components'

import CategoryTableBody from '../../components/category/CategoryTableBody'
import { CategoryListInterface } from '../../interfaces/category'
import { Pagination } from '../../interfaces/common'
import TablePaperContainer from '../common/TablePaperContainer'

const StyledTableHead = styled(TableHead)`
  background-color: rgba(0, 0, 0, 0.02);
`

const StyledTableHeadCell = styled(TableCell)`
  font-size: 16px !important;
  font-weight: 700 !important;
`

const CategoryListTable: FC<any> = ({
  categoryList,
  handleChangePage,
  handleChangeRowsPerPage
}: {
  categoryList: Pagination<CategoryListInterface> | null
  handleChangePage: (...args: any) => void
  handleChangeRowsPerPage: (...args: any) => void
}) => {
  const categories = R.pathOr([], ['result'], categoryList)
  const page = R.pathOr(1, ['page'], categoryList)
  const limit = R.pathOr(50, ['limit'], categoryList)
  const total = R.pathOr(0, ['total'], categoryList)

  const columnNameList = [
    'Id',
    'Sequential #',
    'Type',
    'Category Name',
    'Created At',
    'Updated At',
    'Updated By'
  ]

  return (
    <TablePaperContainer>
      <TableContainer component={Paper} style={{ height: 'inherit' }}>
        <Table aria-label="sticky pagination table">
          <StyledTableHead>
            <TableRow>
              {columnNameList.map((name) => (
                <StyledTableHeadCell align="center">{name}</StyledTableHeadCell>
              ))}
            </TableRow>
          </StyledTableHead>
          <CategoryTableBody categories={categories} />
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[50, 100]}
        count={total}
        rowsPerPage={limit}
        page={page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        style={{ minWidth: '500px' }}
      />
    </TablePaperContainer>
  )
}

export default CategoryListTable
